import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarFonteByIdService } from "../../../services/buscarFonteByIdService";

export const useBuscarFonteById = (
  fonteId: number | undefined | null,
  fetch: boolean
) => {
  const [fonte, setFonte] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as Fonte
  useEffect(() => {
    const fetchLead = async () => {
      if (fonteId && fetch) {
        setIsLoading(true);
        try {
          const data = await buscarFonteByIdService(fonteId);
          if (data) {
            setFonte(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar Fonte:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLead();
  }, [fonteId, fetch]);

  return { fonte, isLoading };
};
